'use client';

import { useTheme } from '@emotion/react';
import {
  MetricaExperimentsContext,
  useExperimentsContext,
} from 'yandex-metrica-ab-react';
import { useEffect } from 'react';
import { Layout } from '../../components/layout/Layout';
import { Container } from '../../components/layout/Container';
import { H1 } from '../../components/styled/typography';
import { DEVICE_SCREENS_MAX_STRING } from '../../lib/consts';
import { CollapsableRotate } from '../../components/collapsable/collapsable';
import { BreadCrumbs } from '../../components/blocks/BreadCrumbs';
import { City, Faq, Page as PageType, Social } from '../../models';
import { Contact } from '../../models/contact';
import { Category } from '../../models/categories';

function PageComponentInner({
  currentCity,
  faqList,
}: {
  currentCity: City;
  faqList: { results: Faq[] };
}) {
  const theme = useTheme();
  const experimentsContext = useExperimentsContext();

  // todo for test task 469; will be fix in #600
  useEffect(() => {
    if (experimentsContext.ready) {
      console.log(experimentsContext);
    }
  }, [experimentsContext]);

  return (
    <Container
      css={{
        padding: '15px 14px',
        [DEVICE_SCREENS_MAX_STRING.md]: {
          padding: '15px 16px',
        },
      }}
    >
      <BreadCrumbs
        currentCity={currentCity}
        items={[{ title: 'Вопрос — ответ' }]}
      />
      <H1
        css={{
          fontFamily: 'Montserrat',
          color: '#282828',
          fontWeight: 700,
          marginTop: 24,
          [DEVICE_SCREENS_MAX_STRING.md]: {
            marginTop: 12,
          },
        }}
      >
        Вопрос — ответ
      </H1>
      <main
        itemScope
        itemType='https://schema.org/FAQPage'
        css={{ fontFamily: 'Golos', color: theme.colors.black }}
      >
        <div
          css={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            paddingTop: 40,
          }}
        >
          <div css={{ width: 790 }}>
            {faqList.results.map((item) => (
              <div
                css={{
                  borderRadius: 4,
                  backgroundColor: theme.colors.white,
                  padding: '16px 20px',
                  marginBottom: 10,
                  fontWeight: 'bold',
                }}
                key={`fagItem${item.id}`}
                itemScope
                itemProp='mainEntity'
                itemType='https://schema.org/Question'
              >
                <div
                  itemProp='name'
                  css={{
                    display: 'none',
                  }}
                >
                  {item.question}
                </div>
                <div
                  itemScope
                  itemProp='acceptedAnswer'
                  itemType='https://schema.org/Answer'
                  css={{
                    display: 'none',
                  }}
                >
                  <div
                    itemProp='text'
                    dangerouslySetInnerHTML={{ __html: item.answer }}
                  />
                </div>
                <CollapsableRotate
                  head={
                    <div
                      css={{
                        color: 'rgba(0, 0, 0, 0.5)',
                        textAlign: 'left',
                        width: '100%',
                      }}
                    >
                      {item.question}
                    </div>
                  }
                  body={
                    <div
                      css={{
                        fontWeight: 500,
                        paddingTop: 16,
                        a: { color: theme.colors.red },
                        ul: {
                          display: 'block',
                          listStyleType: 'disc',
                          marginBlockStart: '1em',
                          marginBlockEnd: '1em',
                          marginInlineStart: 0,
                          marginInlineEnd: 0,
                          paddingInlineStart: 40,
                        },
                      }}
                      dangerouslySetInnerHTML={{ __html: item.answer }}
                    />
                  }
                />
              </div>
            ))}
          </div>
        </div>
      </main>
    </Container>
  );
}

export function PageComponent({
  currentCity,
  faq,
  footerProps,
  categoriesForHeader,
  yandexMetricaData,
}: {
  currentCity: City;
  faq: { results: Faq[] };
  footerProps: {
    pageList: { results: PageType[] };
    socials: { results: Social[] };
    socialsLinks: { results: Social[] };
    contactList: { results: Contact[] };
  };
  categoriesForHeader: Category[];
  yandexMetricaData: any;
}) {
  return (
    <MetricaExperimentsContext.Provider value={yandexMetricaData}>
      <Layout
        categoriesForHeader={categoriesForHeader}
        footerProps={footerProps}
        currentCity={currentCity}
      >
        <PageComponentInner currentCity={currentCity} faqList={faq} />
      </Layout>
    </MetricaExperimentsContext.Provider>
  );
}
